import ProgressBarIndicator from './component.jsx'
export default ProgressBarIndicator
